import type { ValueOf } from 'type-fest';

export const STEPS = {
  DETAILS: 'DETAILS',
  REVIEW: 'REVIEW',
  UNIT_ENTRY: 'UNIT_ENTRY',
  PROPERTY_DETAILS: 'PROPERTY_DETAILS',
  SUCCESS: 'SUCCESS',
} as const;

export type Step = ValueOf<typeof STEPS>;
